<template>
  <div>
    <div
      class="loading flex justify-center"
      style="min-height: 7rem; margin-top: 2rem"
    >
      <span class="size bg-color-23"></span>
      <span class="size bg-color-23"></span>
      <span class="size bg-color-23"></span>
    </div>
  </div>
</template>

<script>
// /index/second/auto?autologin=false&token=627CB9AD8E40779856C9852D31FFF9DAD7AA19C1691D0AAAD846622E72BD7E9240D72EA2D7FFD1DB10DD7F6C0E894DE43557843B9B13F96B13255409D808CFB81A09F74F1D254C36144F1D9EA2C56AA33E3DA1C14F442B83D27FD04D306274B27D1EDD58231A23E7DC4DEB3369EC6632DD70615E375DB8BF40C5F385C27EA3D11714C07D22D7FF2F800A851111EC95FF4743B78436D3D20870D7A5179856F5ECC2CCF2A67A2C5DD6FDB7F09487B85B66A43CE7C015359B0841BDFB120D9185B49AC92F06455A364E64B113EB4593F15F99AB172CC2477AC2C35FA0B5790C3885139420F92C33AB13
import common from "@/utils/common.js";
export default {
  created() {
    console.log(this.$route.params);
    var token = common.getCookie("utoken") || '';
    console.log('--------', token);
    if (token == "") {
      if (this.$route.query.first == "false") {
        var http =
          common.httpcompany +
          this.$route.query.gid +
          "&productId=3&redirectUrl=" +
          encodeURI(common.http + "AutoLogin/login?first=true&gid=0");
        window.open(http, "_self");
      } else {
        var httpurl = localStorage.getItem("islogin_httpurl") || "";
        if (httpurl == "") {
          httpurl = common.http;
        }
        window.location.replace(httpurl);
      }
    } else {
      var httpurl = localStorage.getItem("islogin_httpurl") || "";
      if (httpurl == "") {
        httpurl = common.http;
      }
      window.location.replace(httpurl);
    }
  },
  methods: {
     getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/view/autoLogin/login.vue